import { siteffix, useSite } from '@/store'
import dayjs from 'dayjs'
// todo:timezone

export const removeTime = (s:string) => {
  return s.replace(/\s\d{2}:\d{2}:\d{2}$/g, '')
}

export const transDate = (s:string) => {
  const site = useSite()
  const formatter = /\d{2}:\d{2}:\d{2}/.test(s) ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
  return dayjs(s).add(1, 'hour').format(formatter)
}

export const setValue = (data:any, keys?:string[]) => {
  const suffix = siteffix()
  for (const key in data) {
    if (keys && !keys.includes(key)) {
      // todo
    }
    const value = data[key]
    if (key.endsWith(suffix) && (typeof value === 'string' || value === null)) {
      const newKey = key.replace(suffix, '')
      if (!(newKey in data)) {
        data[newKey] = value
      }
    }
    if (typeof value === 'string' && /^(\d{4})-(\d{2})-(\d{2})(\s+(.*))?$/g.test(value)) {
      data[key] = transDate(value)
    }
    if (typeof value === 'object') {
      setValue(value, keys)
    }
  }
}

const setSite = (data:any, keys?:string[]) => {
  setValue(data, keys)
  return data
}

declare global{
  interface Promise<T>{
    setSite:(fn:(a:T)=>any, keys?:string[])=>Promise<T>
  }
}

/* eslint-disable */
Promise.prototype.setSite = function (fn,keys) {
  return this.then((res) => {
    const data=setSite(res,keys)
    return fn(data)
  })
}